import { createReducer } from '@reduxjs/toolkit';
import {
  accountListSuccessResponse,
  setDrawDownAccount,
  setRepaymentAccount,
  setMainBankAccount,
  accountDetailsByIdSuccess
} from 'actionCreators/account';
import { LOAN_TYPE } from 'constants/general';

const accountReducer = createReducer({
  accountList: [],
  drawDownAccountId: null,
  repaymentAccountId: null,
  mainBankAccountId: null,
  accountDetailList: []
}, (builder) => {
  builder.addCase(accountListSuccessResponse, (state, action) => {
    const accountDetailList = [];
    action.payload.forEach((account) => {
      if (account.type !== LOAN_TYPE) {
        const { id, type, product, balances, number } = account;
        accountDetailList.push({
          id,
          type,
          product,
          balances,
          number
        });
      }
    });

    return { ...state, accountList: action.payload, accountDetailList: accountDetailList };
  });

  builder.addCase(setDrawDownAccount, (state, action) => {
    return { ...state, drawDownAccountId: action.payload };
  });

  builder.addCase(setRepaymentAccount, (state, action) => {
    return { ...state, repaymentAccountId: action.payload };
  });

  builder.addCase(setMainBankAccount, (state, action) => {
    return { ...state, mainBankAccountId: action.payload };
  });

  builder.addCase(accountDetailsByIdSuccess, (state, action) => {
    const accountList = [...state.accountDetailList];
    const { id, type, product, balances, number } = action.payload;
    accountList.push({
      id,
      type,
      product,
      balances,
      number
    });

    return { ...state, accountDetailList: accountList };
  });
});

export { accountReducer };
